// Deep links skip Splash, and Splash is where the app checks that a visitor
// is signed in. So when the app starts on any screen other than the public
// ones (sign-in, invitation, email verification), make sure there is a
// session; if there is none, go to Login. Runs once, at startup. Whether
// the session is still valid is the API's call, as it is on the phone.

import { getAuthToken } from '../../../src/services/auth/tokenStorage';
import { navigationRef } from '../../../src/services/navigationService';

const PUBLIC_ROOTS = new Set(['Auth', 'AcceptInvitation', 'FamilyInvite', 'EmailVerificationResult']);

export function guardInitialDeepLink(): () => void {
  let cancelled = false;
  const check = async () => {
    if (cancelled || !navigationRef.isReady()) return false;
    const state = navigationRef.getRootState();
    const root = state?.routes?.[state.index ?? 0]?.name;
    if (!root || PUBLIC_ROOTS.has(root)) return true;
    const token = await getAuthToken();
    if (cancelled) return true;
    if (!token) {
      navigationRef.resetRoot({
        index: 0,
        routes: [{ name: 'Auth', state: { routes: [{ name: 'Login' }] } }],
      });
    }
    return true;
  };
  const poll = setInterval(async () => {
    if (await check()) clearInterval(poll);
  }, 100);
  return () => {
    cancelled = true;
    clearInterval(poll);
  };
}
